import React, { useCallback, useMemo } from 'react';
import DT from 'duration-time-conversion';
import cn from 'classnames';
import { parseTime } from '../../../../../../shared/utils';
import Logger from '../../../../../../services/Logger';
import s from '../Markers.module.scss';

const OcrMarkers = ({
  data, handleLeftStickyMarker, handleRightStickyMarker, handleCommentMarker, setCurrentTime, assetId,
}) => {
  /** We need to combine markers with the same startTime */
  const preparedData = useMemo(() => {
    const combinedMarkers = {};
    data.forEach((ocr, index) => {
      const { startTime } = ocr;
      if (!combinedMarkers[startTime]) {
        combinedMarkers[startTime] = [];
      }
      combinedMarkers[startTime].push({ index, ...ocr });
    });
    return Object.values(combinedMarkers);
  }, [data]);

  const handleClick = useCallback((startTime, value) => () => {
    const time = DT.t2d(startTime);
    Logger.log('User', 'PreviewTimelineOCRTimeCodeClicked', {
      assetId,
      timestamp_sec: time,
      entity_value: value,
    });
    setCurrentTime(time);
  }, [assetId, setCurrentTime]);

  return preparedData.map((ocr) => (
    <div
      key={ocr[0].index}
      className={cn(s.itemMarker, {
        [s.leftStickyMarker]: handleLeftStickyMarker(ocr[0], 'startTime'),
        [s.rightStickyMarker]: handleRightStickyMarker(ocr[0], 'startTime'),
      })}
      style={{ left: `${handleCommentMarker(ocr[0], 'startTime')}%` }}
      role="presentation"
      onClick={handleClick(ocr[0].startTime, ocr.map((item) => item.text).join(' | '))}
    >
      <div className={s.itemMarkerData}>
        {ocr.map((item) => (
          <div key={item.index} className={s.itemMarkerDataText}>
            <div className={s.itemMarkerDataTitle}>OCR {item.markerOrder || item.index + 1} {' '}
              <span className={s.itemMarkerDataTextTime}>
                ({parseTime(DT.t2d(item.startTime))}
                <If condition={item.endTime}>
                  {' '}- {parseTime(DT.t2d(item.endTime))}
                </If>
                )
              </span>
            </div>
            {item.text}
          </div>
        ))}
      </div>
    </div>
  ));
};
export default OcrMarkers;
